$('.search-toggle').click(function () {
  $('.search-toggle-dropdown').toggleClass('open');
  $('.navigation-desktop-right-menu').toggleClass('search-open');
  $('#navigation').collapse(
    'hide'
  );
  $('.search-toggle-dropdown').collapse(
    'toggle'
  );
  // Focus the search input when the dropdown is toggled
  setTimeout(() => {
    $('#search').focus();
  }, 0);
});

$('.search-toggle-in-navigation').click(function () {
  $('.search-toggle-in-navigation-dropdown').toggleClass('open');
  $('.search-toggle-in-navigation').toggleClass('open');
});


$('.navigation-toggle').click(function () {
  $('.search-toggle-dropdown').collapse(
    'hide'
  );
});
